/**
 * Check Student Access RPC 契约（identity/check-student-access，1 端点）。
 *
 * 校验当前用户是否可访问指定学员详情。
 * 端点权限映射（实现层 requirePermissionsEffect 声明，与旧 serverFn
 * middleware access([...]) 一一对应）：
 * - checkStudentAccess → STUDENT_READ_ALL | STUDENT_READ_ASSIGNED
 *   （resolveScope byStudent；Bottom → 403）
 */
import * as Rpc from "effect/unstable/rpc/Rpc";
import * as RpcGroup from "effect/unstable/rpc/RpcGroup";
import { studentAccessInputSchema } from "@/domain/identity/student-access";
import { Schema } from "effect";
import { asContractSchema, RpcAppError } from "../errors";
import { RpcAuthMiddleware } from "../middleware";

export class CheckStudentAccessRpc extends RpcGroup.make(
  Rpc.make("checkStudentAccess", {
    payload: asContractSchema(studentAccessInputSchema),
    success: Schema.Struct({ hasAccess: Schema.Literal(true) }),
    error: RpcAppError,
  }),
).middleware(RpcAuthMiddleware) {}
